import { FAILURE, IDLE, REQUEST, SUCCESS } from 'src/redux/constants';
import { IMPORT_SURVEYS } from './constants';
import { ThunkAction } from 'redux-thunk';
import { State } from 'src/redux/reducer';
import { ImportSurveysDataActionTypes } from './types';
import api from 'src/utils/api';
import { push } from 'connected-react-router';
import { LocalStorageKeysEnum } from 'src/utils/enum';
import { setTitleNew } from '../titleCreateTest/actions';
import { CreateTestNewTitle } from 'src/config/config';
import { changeStatusSurveyIdle } from '../changeSurveyStatus/actions';
import { oneSurveyIdle } from '../oneSurvey/actions';
import { clearAllListQuestions } from '../../questions/allListQuestions/actions';

export const loadImportSurveys =
  (
    data: any,
  ): ThunkAction<Promise<void>, State, null, ImportSurveysDataActionTypes> =>
  async (dispatch: any) => {
    dispatch({ type: IMPORT_SURVEYS + REQUEST });
    try {
      const payload = await api.loadImportSurvey(data);
      dispatch({ type: IMPORT_SURVEYS + SUCCESS, payload });
      dispatch(setTitleNew(CreateTestNewTitle));
      dispatch(changeStatusSurveyIdle());
      dispatch(oneSurveyIdle());
      dispatch(clearAllListQuestions());
      dispatch(push(`/createTest/${payload.id}`));
      localStorage.setItem(LocalStorageKeysEnum.ID_SERVEY, payload.id);
    } catch (error) {
      dispatch({ type: IMPORT_SURVEYS + FAILURE, error });
    }
  };

export const importSurveysIdle = () => ({ type: IMPORT_SURVEYS + IDLE });
